<template>
  <d2-container>
    <el-card class="filter-container" shadow="never">
      <div>
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px">筛选搜索</span>
        <el-button  :disabled="!user_btn_add" style="float: right; margin-left: 10px" type="success" @click="handleExcel" size="small">
          导出Excel表格 <i class="el-icon-download el-icon--right"></i
        ></el-button>
        <el-button style="float: right" type="primary" @click="handleSearchList" size="small"> 查询搜索 <i class="el-icon-search"></el-button>
        <el-button style="float: right" @click="handleResetSearch" size="small"> 重置表单 <i class="el-icon-refresh"></el-button>
      </div>
      <div style="margin-top: 15px">
        <el-form :inline="true" :model="listQuery" size="small" label-width="140px">
          <el-form-item label="姓名：">
            <el-input v-model="listQuery.name" class="input-width" placeholder="姓名" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号码："> 
            <el-input v-model="listQuery.phone" maxlength=11 class="input-width" placeholder="联系电话" clearable></el-input>
          </el-form-item>
          <el-form-item label="账号状态：">
            <el-select v-model="listQuery.status" class="input-width" placeholder="全部" clearable>
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用户类型：">
            <el-select v-model="listQuery.type" class="input-width" placeholder="全部" clearable>
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="毕业年份：">
            <el-select v-model="listQuery.classesId" class="input-width" placeholder="全部" clearable>
              <el-option v-for="item in classesList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>

        </el-form>
      </div>
    </el-card>

    <el-button
      type="primary"
      :disabled="!user_btn_add"
      size="medium"
      icon="el-icon-circle-plus"
      style="margin-top:10px"
      @click="saveUser()"
    >
      添加
    </el-button>

    <div class="table-container">
      <el-table
        ref="orderTable"
        :data="list"
        style="width: 100%; margin: 10px 0 15px"
        @selection-change="handleSelectionChange"
        v-loading="listLoading"
        border
        stripe
      >
        <el-table-column type="selection" width="60" align="center"></el-table-column>
        <el-table-column type="index" label="#" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (listQuery.pageNum - 1) * listQuery.pageSize }}
          </template>
        </el-table-column>

        <el-table-column align="center" label="姓名">
          <template slot-scope="scope">
            <span>{{ scope.row.name ? scope.row.name : "" }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="毕业年份">
          <template slot-scope="scope">
            <span>{{ scope.row.classesName }}</span>
          </template>
        </el-table-column>

        
        <el-table-column align="center" label="工作单位">
          <template slot-scope="scope">
            <span>{{ scope.row.jobName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="联系电话">
          <template slot-scope="scope">
            <span>{{ scope.row.phone }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <el-link v-if="scope.row.status == 1" :underline="false" type="success" disabled>正常</el-link>
            <el-link v-else type="danger" :underline="false" disabled>禁用</el-link>
          </template>
        </el-table-column>
<!--0普通用户 1 待审核用户  2审核拒接  3 校友 4 管理员-->
        <el-table-column align="center" label="用户类型">
          <template slot-scope="scope">
            <el-link v-if="scope.row.type == 0" :underline="false"  disabled>普通用户</el-link>
            <el-link v-if="scope.row.type == 1" :underline="false" type="warning"  disabled>待审核用户</el-link>
            <el-link v-if="scope.row.type == 2" :underline="false" type="danger"  disabled>审核拒接</el-link>
            <el-link v-if="scope.row.type == 3" :underline="false" type="success"  disabled>校友用户</el-link>
            <el-link v-if="scope.row.type == 4" type="primary" :underline="false" disabled>管理员</el-link>
          </template>
        </el-table-column>

        <el-table-column align="center" label="注册时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="handleUpdate(scope.row)" v-if="scope.row.type == 0 || scope.row.type == 3 || scope.row.type == 4 " > 修改信息 </el-button>
            <el-button size="small" type="warning" v-if="scope.row.type == 1" @click="handleExamine(scope.row)"> 审核信息 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <template slot="footer">
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes,prev, pager, next,jumper"
          :current-page.sync="listQuery.pageNum"
          :page-size="listQuery.pageSize"
          :page-sizes="[5, 10, 15, 20, 30, 50]"
          :total="total"
        >
        </el-pagination>
      </div>
    </template>

    <el-dialog title="用户属性" :visible.sync="dialogFormVisible" width="30%" :before-close="handleFormClose">
      <el-form :model="form" size="small" label-width="140px" ref="form" :rules="rules">
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="手机号码：" prop="phone">
          <el-input v-model="form.phone" maxlength=11 autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="工作单位：">
          <el-input v-model="form.jobName" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="毕业年份：" prop="classesId">
          <el-select v-model="form.classesId" clearable style="width: 100%">
            <el-option v-for="item in classesList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="性别：">
          <el-select v-model="form.sex" clearable style="width: 100%">
            <el-option v-for="item in sexList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="用户类型：" prop="type">
          <el-select v-model="form.type" clearable style="width: 100%">
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="照片：" prop="icon">
          <el-upload
            class="avatar-uploader"
            :action="ossUploadUrl"
            :http-request="uploadFileImg"
            :show-file-list="false"
            :before-upload="beforeUploadImg"
          >
            <img v-if="form.icon" :src="form.icon" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="状态：">
          <el-switch
            style="display: block; line-height: 24px"
            v-model="status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="开启"
            inactive-text="禁用"
          >
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleFormClose">取 消</el-button>
        <el-button type="primary" @click="handleSave">确 定</el-button>
      </div>
    </el-dialog>



    <el-dialog title="审核意见" :visible.sync="dialogExamineFormVisible" width="30%" :before-close="handleExamineClose">
      <el-form :model="form" size="small" label-width="140px" ref="form" :rules="rules">

        <el-form-item label="照片：" prop="icon">
          <el-upload
            class="avatar-uploader"
            :action="ossUploadUrl"
            :http-request="uploadFileImg"
            :show-file-list="false"
            :before-upload="beforeUploadImg"
          >
            <img v-if="form.icon" :src="form.icon" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="姓名：" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="手机号码：" prop="phone">
          <el-input v-model="form.phone" maxlength=11 autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="毕业年份：" prop="classesId">
          <el-select v-model="form.classesId" clearable style="width: 100%">
            <el-option v-for="item in classesList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="工作单位：">
          <el-input v-model="form.jobName" autocomplete="off"></el-input>
        </el-form-item>

         <el-form-item label="审核意见：" prop="type">
          <el-select v-model="form.type" clearable style="width: 100%">
            <el-option v-for="item in examineList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注信息：" v-if="form.type == 2" prop="remark">
          <el-input v-model="form.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入修改意见..." ></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleExamineClose">取 消</el-button>
        <el-button type="primary" @click="handleExamineSave">确 定</el-button>
      </div>
    </el-dialog>

    </el-drawer>
  </d2-container>
</template>

<script>
import { page, saveAndUpdate, classesList } from "@/api/workbench/person/index"
import util from "@/libs/util"
import axios from "axios"
const defaultListQuery = {
  pageNum: 1,
  pageSize: 10,
  status: null,
  name: null,
  phone: null,
  type:null,
  classesId: null
}
export default {
  name: "personList",
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请填写真实姓名", trigger: "blur" }],
        phone: [
          { required: true, message: "请填写手机号码", trigger: "blur" },
          { min: 11, max: 11, message: '手机号码长度错误', trigger: 'blur' }
        ],
        classesId: [{ required: true, message: "请选择毕业年份", trigger: "blur" }],
        icon: [{ required: true, message: "请上传头像", trigger: "blur" }],
        type: [{ required: true, message: "请填写用户类型", trigger: "blur" }],
        remark: [{ required: true, message: "请填写修改意见", trigger: "blur" }]
      },

      user_btn_add: this.hasPermissions(["userList:btn_add"]),

      listQuery: Object.assign({}, defaultListQuery),
      listLoading: true,
      list: null,
      total: null,
      api: process.env.VUE_APP_API,
      multipleSelection: [],
      classesList: [],
      dialogVisible: false,
      dialogIntegral: false,
      statusOptions: [
        { label: "禁用", value: 0 },
        { label: "启用", value: 1 }
      ],
      sexList: [
        { name: "男", id: 1 },
        { name: "女", id: 2 }
      ],
      typeList: [
        { name: "普通用户", id: 0 },
        { name: "校友用户", id: 3 },
        { name: "管理员用户", id: 4 },
      ],
      examineList: [
        { name: "暂不审核", id: 1 },
        { name: "拒接用户", id: 2 },
        { name: "同意用户", id: 3 },
      ],
      fileDataImg: null,
      typeOptions: [ 
        { label: "普通用户", value: 0 },
        { label: "待审核用户", value: 1 },
        { label: "审核拒接用户", value: 2 },
        { label: "校友用户", value: 3 },
        { label: "管理员用户", value: 4 },
      ],
      ossUploadUrl: process.env.VUE_APP_API + "/tool/oss/upload",
      form: {
        id: null,
        phone: "",
        classesId: null,
        type: null,
        icon: "",
        name: "",
        sex: "",
        jobName: "",
        status: null,
        remark:null
      },
      status: true,
      dialogFormVisible: false,
      dialogExamineFormVisible: false
    }
  },
  activated() {
    if(this.$route.query.type){
      this.listQuery.type =  this.$route.query.type
    }
    this.getList(),
    this.getClassesList()
  },
  watch: {
    listQuery: {
      handler(val) {
        Object.keys(val).forEach(key => {
          if (!val[key] && val[key] !== 0) val[key] = undefined
        })
      },
      deep: true
    }
  },
  methods: {
    handleExcel() {
      const query = { ...this.listQuery }
      query.pageNum = null
      query.pageSize = null
      axios.post(process.env.VUE_APP_API + "/admin/user/export", query, { responseType: "blob" }).then(res => {
        if (!res.data) {
          this.$message.warning("无用户数据")
          return
        }

        if ("msSaveOrOpenBlob" in navigator) {
          window.navigator.msSaveOrOpenBlob(blob, "国兴人用户表.xlsx")
        } else {
          const elink = document.createElement("a")
          let blob = new Blob([res.data])
          elink.download = "国兴人用户表.xlsx"
          elink.style.display = "none"
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }
      })
    },
    changeIntegralType(val) {
      this.integralform["integralType"] = val
      if (val != 1) {
        this.integralform.type = 1
      }
      selectUserIntegral(this.integralform).then(response => {
        this.sourceId = null
        this.sourceList = response
      })
    },
    changeType(val) {
      this.integralform["type"] = val
      if (this.integralform.integralType) {
        selectUserIntegral(this.integralform).then(response => {
          this.sourceId = null
          this.sourceList = response
        })
      }
    },
    handleSave() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.form.status = this.status ? 1 : 0
          saveAndUpdate(this.form).then(response => {
            this.$message.success("用户信息更改成功!")
            this.handleFormClose()
            this.getList()
          })
        } else {
          return false
        }
      })
    },
    handleExamineSave() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.form.ifStatus = this.form.type
          this.form.status = this.status ? 1 : 0
          saveAndUpdate(this.form).then(response => {
            this.$message.success("用户信息审核成功!")
            this.handleExamineClose()
            this.getList()
          })
        } else {
          return false
        }
      })
    },
    uploadFileImg(file) {
      this.fileDataImg = new FormData()
      this.fileDataImg.append("file", file.file)
      axios.post(this.ossUploadUrl, this.fileDataImg, { headers: { "Content-Type": "multipart/form-data" } }).then(res => {
        this.form.icon = res.data.data
      })
    },
    //附件相册上传
    beforeUploadImg(file) {
      const allowType = ["image/jpeg", "image/png"]
      const allowSize = 1024 * 1024 * 10
      if (!allowType.includes(file.type)) {
        this.$message.error("仅支持 JPG 和 PNG 格式!")
        return false
      }
      if (file.size > allowSize) {
        this.$message.error("大小不能超过 10MB!")
        return false
      }
      return true
    },
    handleUpdate(row) {
      this.form = row
      this.status = this.form.status == 1 ? true : false
      this.dialogFormVisible = true
    },

    handleExamine(row){
      this.form =row,
      this.dialogExamineFormVisible =true
    },
  
    saveUser(){
      this.form ={
        id: null,
        phone: "",
        classesId: "",
        icon: "",
        name: "",
        sex: "",
        jobName: "",
        status: 1
      }
      this.status = this.form.status == 1 ? true : false
      this.dialogFormVisible = true
    },
    handleUploadError() {
      this.$message.error("上传失败")
    },
    handleUploadSuccess(res) {
      this.handleClose()
      this.$message.success("上传成功")
      this.getList()
    },
    handleClose() {
      this.dialogVisible = false
    },
    handleFormClose() {
      this.dialogFormVisible = false
      this.getList()
    },
    handleExamineClose(){
      this.dialogExamineFormVisible =false,
      this.getList()
    },
    handleImport() {
      this.dialogVisible = true
    },
    getList() {
      this.listLoading = true
      page(this.listQuery).then(response => {
        this.listLoading = false
        this.list = response.rows
        this.total = response.total
      })
    },
    getClassesList() {
      classesList().then(response => {
        this.classesList = response
      })
    },
    handleResetSearch() {
      this.listQuery = Object.assign({}, defaultListQuery)
    },
    handleSearchList() {
      this.listQuery.pageNum = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val
      this.getList()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    }
  }
}
</script>

<style lang="scss" scoped>
.drawer {
  /deep/ .el-drawer {
    width: 400px !important;
  }
}
.integralText {
  color: #b0b7c2;
  font-size: 10px;
}
.block {
  margin: 40% 0px;
  /deep/ ul.el-timeline {
    padding: 0px 0px 0px 15px;
  }
}
.input-width {
  width: 203px;
}
.el-button {
  margin-bottom: 10px;
}
/deep/ .el-dialog__body {
  padding: 0 10px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #b0b7c2;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.drawer-integral {
  padding: 5px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .dialog-footer-integral {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
}
</style>
